module.exports = "<h2><mat-icon style=\"vertical-align: middle\">error</mat-icon>&nbsp; {{loc.get('DialogLimitErrorTitle')}}</h2>\n<p [innerHTML]=\"loc.get('DialogLimitErrorBody')\">\n</p>\n<a *ngIf=\"isIT\" href=\"tel:800178712\"><img src=\"assets/num_verde.png\"></a>\n<div style=\"text-align: right; margin-top: 10px\">\n  <button mat-raised-button (click)=\"closeDialog()\">{{loc.get('Chiudi')}}</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialogs/limit-error-dialog/limit-error-dialog.html
// module id = ./src/app/dialogs/limit-error-dialog/limit-error-dialog.html
// module chunks = main